var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-month-picker',{on:{"change":_vm.onChange},model:{value:(_vm.data.date),callback:function ($$v) {_vm.$set(_vm.data, "date", $$v)},expression:"data.date"}})}
var staticRenderFns = []

export { render, staticRenderFns }